module.exports = __webpack_public_path__ + "img/2.82e7e092.png";